import { router } from "@inertiajs/vue3";

router.on("success", (event) => {
    const token = event.detail.page.props.csrf_token;
    const meta = document.head?.querySelector('meta[name="csrf-token"]');

    if (typeof token === "string" && token !== "" && meta) {
        meta.setAttribute("content", token);
    }
});
